/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-dupe-keys */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { useParams, useNavigate } from "react-router-dom";
import {
  getBusinessLoanById,
  updateBusinessLoan,
  getAllAdmins,
  getAllCities,
  getAllStates,
  getAllPincode,
  getBusinessLoanByEmail,
  getBusinessLoanByMobile,
  getBusinessLoanBankList
} from "../../../middleware/backend_hepler";
import LabeledInput from "../../../components/LabeledInput";
import LabeledSelect from "../../../components/LabeledSelect";
import LabeledSelectAgent from "../../../components/LabeledSelectAgent";
import LabeledDropDown from "../../../components/LabeledDropDown";
import { Stepper, Step, StepLabel } from "@mui/material";
import { Row, Col, Button } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { validationRules, validateDOB } from "../../../utils/validationRules";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../../../assets/logo.png";
import { FaTrashAlt } from "react-icons/fa";


const EditBusinessLoan = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [cities, setCities] = useState([]);
  const [pincodes, setPincodes] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [pincodeOptions, setPincodeOptions] = useState([]);
  const [presentCityOptions, setPresentCityOptions] = useState([]);
  const [presentPincodeOptions, setPresentPincodeOptions] = useState([]);
  const [error, setError] = useState(null);
  const [mobileExists, setMobileExists] = useState(false);
  const [emailExists, setEmailExists] = useState(false);
  const [initialEmail, setInitialEmail] = useState("");
  const [initialMobile, setInitialMobile] = useState("");
  const { adminRole, adminName, adminId } = useContext(AuthContext);
  const [status, setStatus] = useState("");
  const [selectedState, setSelectedState] = useState(null);
  const [filteredStates, setFilteredStates] = useState([]);
  const [selectedPresentState, setSelectedPresentState] = useState(null);
  const [businessLoanBanks, setBusinessLoanBanks] = useState([]);
  const [files, setFiles] = useState({});

  const fileRefs = {
    pan: useRef(null),
    aadhar: useRef(null),
    photo: useRef(null),
    bank_account: useRef(null),
    itr: useRef(null),
    gst: useRef(null),
    msme: useRef(null),
    others: useRef(null),
    co_applicant_pan: useRef(null),
    co_applicant_aadhar: useRef(null),
    co_applicant_photo: useRef(null),
  };

  const steps = ["Personal Details", "Income Details", "Upload Documents"];

  const methods = useForm({
    defaultValues: {
      created_id: "",
      created_by: "",
      assigned_to: "",
      status: "",
      rejected_reason: "",
      employee_type: "",
      name: "",
      dob: "",
      age: "",
      father_name: "",
      mother_name: "",
      marital_status: "",
      spouse_name: "",
      residence_type: "",
      landmark: "",
      mobile: "",
      email: "",
      location: "",
      state: "",
      pincode: "",
      city: "",
      present_address_adhaar: "",
      current_location: "",
      current_state: "",
      current_city: "",
      current_pincode: "",
      current_landmark: "",
      add_co_applicant: "",
      co_applicant_name: "",
      co_applicant_dob: "",
      co_applicant_relationship: "",
      co_applicant_spouse_name: "",
      co_applicant_fathers_name: "",
      co_applicant_mothers_name: "",
      co_applicant_son_name: "",
      co_applicant_daughter_name: "",
      required_loan_amount: "",
      turnover: "",
      gst_registered: "",
      existing_emi_amount: "",
      company_type: "",
      gst_registerd_year: "",
      msme_registered: "",
      filling_itr: "",
      add_reference: "",
      reference_name: "",
      reference_mobile: "",
      reference_address: "",
      reference_location: "",
      bank_name: "",
      pan: null,
      aadhar: null,
      photo: null,
      bank_account: null,
      itr: null,
      gst: null,
      msme: null,
      others: null,
      co_applicant_pan: null,
      co_applicant_aadhar: null,
      co_applicant_photo: null,
    },
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const {
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = methods;
  const email = watch("email");
  const mobile = watch("mobile");
  const maritalStatus = watch("marital_status");
  const coApplicantRelationships = watch("co_applicant_relationship");
  const dob = watch('dob');
  const selectedStatus = watch("status");

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const statesData = await getAllStates();
        const availableStates = statesData.filter(
          (state) => state.availability === "Yes"
        );
        setFilteredStates(availableStates);
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };
    fetchStates();
  }, []);

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const citiesData = await getAllCities();
        setCities(citiesData.sort((a, b) => a.name.localeCompare(b.name)));
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };
    fetchCities();
  }, []);

  useEffect(() => {
    const fetchPincodes = async () => {
      try {
        const pincodeData = await getAllPincode();
        setPincodes(pincodeData);
      } catch (error) {
        console.error("Error fetching pincodes:", error);
      }
    };
    fetchPincodes();
  }, []);

  const stateOptions = filteredStates.map((state) => ({
    value: state.name,
    label: state.name,
  }));

  useEffect(() => {
    if (selectedState) {
      const filteredCities = cities.filter(
        (city) => city.State_name === selectedState
      );
      setCityOptions(
        filteredCities.map((city) => ({ value: city.name, label: city.name }))
      );

      const filteredPincodes = pincodes.filter(
        (pincode) => pincode.state === selectedState.toUpperCase()
      );

      setPincodeOptions(
        Array.from(
          new Set(filteredPincodes.map((pincode) => pincode.pincode))
        )
          .sort((a, b) => a - b) 
          .map((pincode) => ({ value: pincode, label: pincode }))
      );
    }  
    if (selectedPresentState) {
      const filteredCities = cities.filter(
        (city) => city.State_name === selectedPresentState
      );
      setPresentCityOptions(
        filteredCities.map((city) => ({ value: city.name, label: city.name }))
      );

      const filteredPincodes = pincodes.filter(
        (pincode) => pincode.state === selectedPresentState.toUpperCase()
      );

      setPresentPincodeOptions(
        Array.from(
          new Set(filteredPincodes.map((pincode) => pincode.pincode))
        )
          .sort((a, b) => a - b) 
          .map((pincode) => ({ value: pincode, label: pincode }))
      );
    } 
  }, [selectedState, selectedPresentState, cities, pincodes]);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await getAllAdmins();
        const filteredEmployees = response.filter(
          (admin) => admin.role === "employee"
        );
        setEmployees(filteredEmployees);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching employees:", error);
      }
    };

    fetchEmployees();
  }, []);

  useEffect(() => {
    const fetchBusinessLoanBanks = async () => {
      try {
        const response = await getBusinessLoanBankList();
        const banksData = response.data.map((bank) => ({
          value: bank.bank_name,
          label: bank.bank_name,
        }));
        banksData.sort((a, b) => a.label.localeCompare(b.label));
        setBusinessLoanBanks(banksData);
      } catch (error) {
        console.error("Error fetching business loan banks:", error);
      }
    };
    fetchBusinessLoanBanks();
  }, []);

  useEffect(() => {
    const fetchLoanData = async () => {
      try {
        const loan = await getBusinessLoanById(id);
        Object.keys(loan).forEach((key) => {
          setValue(key, loan[key]);
        });
        setInitialEmail(loan.email);
        setInitialMobile(loan.mobile);
        setSelectedState(loan.state);
        setSelectedPresentState(loan.current_state);
      } catch (error) {
        console.error("Error fetching business loan data:", error);
      }
    };

    fetchLoanData();
  }, [id, setValue]);

  const checkEmail = async (email) => {
    if (email && email !== initialEmail) {
      try {
        const data = await getBusinessLoanByEmail(email);
        setEmailExists(Boolean(data));
      } catch (error) {
        setEmailExists(false);
      }
    } else {
      setEmailExists(false);
    }
  };

  const checkMobile = async (mobile) => {
    if (mobile && mobile !== initialMobile) {
      try {
        const data = await getBusinessLoanByMobile(mobile);
        setMobileExists(Boolean(data));
      } catch (error) {
        setMobileExists(false);
      }
    } else {
      setMobileExists(false);
    }
  };

  useEffect(() => {
    if (email) {
      checkEmail(email);
    }
  }, [email]);

  useEffect(() => {
    if (mobile) {
      checkMobile(mobile);
    }
  }, [mobile]);

  useEffect(() => {
    if (dob) {
      const birthDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();

      if (
        monthDifference < 0 ||
        (monthDifference === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      if (age >= 0) {
        setValue("age", age);
      } else {
        setValue("age", "");
      }
    }
  }, [dob, setValue]);

  const getInitials = (name) => {
    if (!name) return "";
    const names = name.split(" ");
    const initials = names.map((n) => n.charAt(0).toUpperCase()).join("");
    return initials;
  };

  const employeeOptions = employees.map((employee) => ({
    value: `ID${employee.id} - ${employee.name}`,
    label: (
      <div className="agent-option">
        {employee.photo ? (
          <img
            src={decodeURIComponent(employee.photo)}
            alt={`${employee.name}'s avatar`}
            className="agent-image"
          />
        ) : (
          <div className="agent-image-initials">{getInitials(employee.name)}</div>
        )}
        <span className="agent-details">
          <strong>ID{employee.id}</strong> - {employee.name}
        </span>
      </div>
    ),
  }));

  const onSubmit = async (data) => {
    setLoading(true);
    const formDataToSend = new FormData();
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        formDataToSend.append(key, data[key]);
      }
    });

    try {
      await updateBusinessLoan(id, formDataToSend);
      setLoading(false);
      navigate("/businessloanlist", {
        state: { successMessage: "Business loan updated successfully!" },
      });
    } catch (error) {
      const errorMessage = error.response?.data?.message;

      if (typeof errorMessage === "string") {
        if (errorMessage.includes("Email already exists")) {
          toast.error("Email already exists. Please use a different email.");
        }
        if (errorMessage.includes("Mobile number already exists")) {
          toast.error(
            "Mobile number already exists. Please use a different mobile number."
          );
        }
        if (errorMessage.includes("Mobile number or email already exists")) {
          toast.error(
            "Mobile number or email already exists. Please use different details."
          );
        }
      } else {
        setLoading(false);
        console.error("Error updating business loan:", error);
        toast.error("Failed to update the business loan. Please try again.");
      }
    }
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      setValue(name, files[0]);
      setFiles((prev) => ({
        ...prev,
        [name]: files.length > 0 ? files[0] : null,
      }));
    }
  };

  const handleClearFile = (name) => {
    if (fileRefs[name] && fileRefs[name].current) {
      fileRefs[name].current.value = null;
      setFiles((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const handleViewClick = async (documentType) => {
    try {
      const loan = await getBusinessLoanById(id);
      const documentUrl = loan[documentType]
        ? decodeURIComponent(loan[documentType])
        : null;

      if (documentUrl) {
        window.open(documentUrl, "_blank");
      } else {
        toast.warn(`No file available`);
        console.error(`No ${documentType} document found for this loan.`);
      }
    } catch (error) {
      console.error(`Error fetching ${documentType} document:`, error);
    }
  };

  const handleDownloadClick = async (documentType) => {
    try {
      const loan = await getBusinessLoanById(id);
      let url = loan[documentType];

      if (!url) {
        toast.warn("No file available");
        return;
      }

      url = decodeURIComponent(url);

      // Auto-upgrade to HTTPS in production
      if (window.location.hostname !== "localhost" && url.startsWith("http://")) {
        url = url.replace("http://", "https://");
      }

      // Fetch blob if local or same-origin, otherwise direct link download
      const isLocalOrSameOrigin = url.startsWith(window.location.origin) || window.location.hostname === "localhost";

      if (isLocalOrSameOrigin) {
        const response = await fetch(url);
        if (!response.ok) throw new Error("Failed to fetch the document");
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = `${documentType}_${id}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);

      } else {
        // Cross-origin server file
        const link = document.createElement("a");
        link.href = url;
        const fileName = url.split("/").pop() || `${documentType}_${id}`;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

    } catch (error) {
      console.error(`Error downloading ${documentType} document:`, error);
      toast.error("Failed to download document");
    }
  };

  const handleStepChange = async (newStep) => {
    if (newStep === 1) {
      const isValidStep0 = await methods.trigger();
      if (isValidStep0) {
        if (emailExists) {
          toast.error("Email already exists. Please use a different email.");
          return;
        }
        if (mobileExists) {
          toast.error(
            "Mobile number already exists. Please use a different mobile number."
          );
          return;
        }
        setActiveStep(newStep);
      } else {
        console.log(
          "Please fix validation errors before moving to the next step."
        );
      }
    } else if (newStep === 2) {
      const isValidStep1 = await methods.trigger();
      if (isValidStep1) {
        setActiveStep(newStep);
      } else {
        console.log(
          "Please fix validation errors before moving to the next step."
        );
      }
    } else {
      setActiveStep(newStep);
    }
  };

  if (error) {
    return <div>{error}</div>;
  }

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption?.value || null);
    setValue("state", selectedOption?.value || "");
  };

  const handleBusinessStateChange = (selectedOption) => {
    setSelectedPresentState(selectedOption?.value || null);
    setValue("current_state", selectedOption?.value || "");
  };

  const getSelectedBusinessStateValue = () => {
    return stateOptions.find((option) => option.value === selectedPresentState);
  };

  return (
    <div className="edit-all-loan-container">
      
        <div className="edit-back-icon">
          {activeStep === 0 && (
            <div
              className="edit-back-text"
              onClick={() => navigate("/businessloanlist")}
            >
              &lt; Go Back
            </div>
          )}
          <img src={logo} alt="Logo" className="form-logo" />
        </div>

      <h2>Business Loan</h2>
      <FormProvider {...methods}>
        {loading}
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            className="stepper-container"
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div className="form-content">
            {activeStep === 0 && (
              <div className="sections personal-details-sections">
                <h4>Personal Details</h4>
                <Row>
                  <Col md={6}>
                    <LabeledInput
                      label="Loan ID"
                      name="form_id"
                      disabled={true}
                      style={{
                        backgroundColor: "#f0f0f0",
                        color: "#808080",
                      }}
                      registerOptions={{}}
                    />
                  </Col>
                  {adminRole !== "customer" && ( 
                    <>
                      <Col md={6}>
                        <LabeledInput
                          label="Employee ID"
                          name="created_id"
                          disabled={true}
                          style={{ backgroundColor: "#f0f0f0", color: "#808080" }}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledInput
                          label="Employee"
                          name="created_by"
                          disabled={true}
                          style={{ backgroundColor: "#f0f0f0", color: "#808080" }}
                        />
                      </Col>
                    </>
                  )}
                  {adminRole === "admin" && (
                    <Col md={6}>
                      <LabeledSelect
                        name="assigned_to"
                        label="Assign to"
                        options={employeeOptions}
                        registerOptions={{ required: "Selection is required" }}
                        error={errors.assigned_to?.message}
                        required
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <LabeledDropDown
                      name="status"
                      label="Lead Status"
                      options={[
                        { value: "Open", label: "Open" },
                        { value: "In Process", label: "In Process" },
                        { value: "Pending", label: "Pending" },
                        { value: "Approved", label: "Approved" },
                        { value: "Rejected", label: "Rejected" },
                      ]}
                      registerOptions={{
                        required: "Selection is required",
                        onChange: (e) => {
                          handleStatusChange(e);
                          setValue("status", e.target.value);
                        },
                      }}
                      disabled={adminRole === "customer"}
                      error={errors.status?.message}
                      required
                    />
                  </Col>
                  {watch("status") === "Rejected" && (
                    <Col md={6}>
                      <LabeledDropDown
                        name="rejected_reason"
                        label="Rejected Reason"
                        options={[
                          {
                            value: "CIBIL issue & more than 3 enquiries",
                            label: "CIBIL issue & more than 3 enquiries",
                          },
                          {
                            value: "Recent loan/settlement",
                            label: "Recent loan/settlement",
                          },
                          { value: "Recent DPD", label: "Recent DPD" },
                          {
                            value: "Overdue / Previous loan (HL/PL/BL/CL)",
                            label: "Overdue / Previous loan (HL/PL/BL/CL)",
                          },
                          {
                            value: "Lowest CIBIL score",
                            label: "Lowest CIBIL score",
                          },
                          {
                            value: "Guarantor CIBIL score / Co-Applicant issue",
                            label: "Guarantor CIBIL score / Co-Applicant issue",
                          },
                          {
                            value: "Pincode / Salary / Age criteria not met",
                            label: "Pincode / Salary / Age criteria not met",
                          },
                          {
                            value: "Can apply after 3 months",
                            label: "Can apply after 3 months",
                          },
                          {
                            value: "Never eligible for loan",
                            label: "Never eligible for loan",
                          },
                          {
                            value: "Credit card overdue",
                            label: "Credit card overdue",
                          },
                        ]}
                        registerOptions={{ required: "Selection is required" }}
                        error={errors.rejected_reason?.message}
                        required
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <LabeledInput
                      label="Name"
                      type="text"
                      name="name"
                      registerOptions={validationRules.name}
                      error={errors.name?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      label="Date of Birth"
                      type="date"
                      name="dob"
                      registerOptions={{
                        required: "Date of Birth is required",
                        validate: validateDOB,
                      }}
                      error={errors.dob?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput name="age" label="Age" required readOnly />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="father_name"
                      label="Father Name"
                      registerOptions={validationRules.name}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="mother_name"
                      label="Mother Name"
                      registerOptions={validationRules.name}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      label="Mobile"
                      type="tel"
                      name="mobile"
                      registerOptions={validationRules.mobile}
                      error={errors.mobile?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      label="Email"
                      type="text"
                      name="email"
                      registerOptions={validationRules.email}
                      error={errors.email?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledDropDown
                      name="marital_status"
                      label="Marital Status"
                      options={[
                        { value: "single", label: "Single" },
                        { value: "married", label: "Married" },
                      ]}
                      registerOptions={{
                        required: "Marital status is required",
                      }}
                    />
                  </Col>
                  {maritalStatus === "married" && (
                    <Col md={6}>
                      <LabeledInput
                        name="spouse_name"
                        label="Spouse Name"
                        registerOptions={{
                          required: "Spouse Name is required",
                        }}
                        required
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <LabeledDropDown
                      name="residence_type"
                      label="Residence Type"
                      options={[
                        { value: "Own", label: "Own" },
                        { value: "Rent", label: "Rent" },
                        {
                          value: "Owned By Me / Spouse",
                          label: "Owned By Me / Spouse",
                        },
                        {
                          value: "Owned By My / Parents",
                          label: "Owned By My / Parents",
                        },
                      ]}
                      registerOptions={{
                        required: "Residence type is required",
                      }}
                      error={errors.residence_type?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      label="Present Staying Address"
                      type="text"
                      name="location"
                      registerOptions={{ required: " Address is required" }}
                      error={errors.location?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="landmark"
                      label="Landmark"
                      registerOptions={{ required: " Landmark is required" }}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledSelect
                      name="state"
                      label="State"
                      options={stateOptions}
                      onChange={handleStateChange}
                      error={errors.state?.message}
                      registerOptions={validationRules.State}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledSelect
                      name="city"
                      label="City"
                      options={cityOptions}
                      error={errors.city?.message}
                      registerOptions={validationRules.City}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledSelectAgent
                      name="pincode"
                      label="Pincode"
                      options={pincodeOptions}
                      error={errors.pincode?.message}
                      registerOptions={validationRules.Pincode}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledDropDown
                      label="Is your Present Address as per Aadhaar"
                      name="present_address_adhaar"
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      registerOptions={{ required: "Selection is required" }}
                      error={errors.present_address_adhaar?.message}
                      required
                    />
                  </Col>
                  {watch("present_address_adhaar") === "No" && (
                    <>
                      <Col md={6}>
                        <LabeledInput
                          label="Present Aadhar Address"
                          type="text"
                          name="current_location"
                          registerOptions={{ required: "Address is required" }}
                          error={errors.current_location?.message}
                          required
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledSelect
                          name="current_state"
                          label="State"
                          options={stateOptions}
                          onChange={handleBusinessStateChange}
                          value={getSelectedBusinessStateValue()}
                          error={errors.current_state?.message}
                          registerOptions={validationRules.State}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledSelect
                          name="current_city"
                          label="City"
                          options={presentCityOptions}
                          error={errors.current_city?.message}
                          registerOptions={validationRules.City}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledSelectAgent
                          name="current_pincode"
                          label="Pincode"
                          options={presentPincodeOptions}
                          error={errors.current_pincode?.message}
                          registerOptions={validationRules.Pincode}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledInput
                          name="current_landmark"
                          label="Present Landmark"
                          registerOptions={{ required: "Landmark is required" }}
                          error={errors.current_landmark?.message}
                        />
                      </Col>
                    </>
                  )}
                  <Col md={6}>
                    <LabeledDropDown
                      label="Add Co-Applicant "
                      name="add_co_applicant"
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      registerOptions={{ required: "Selection is required" }}
                      error={errors.add_co_applicant?.message}
                      required
                    />
                  </Col>
                </Row>
                {watch("add_co_applicant") === "Yes" && (
                  <div className="sections co-applicant-details-sections">
                    <h4>Co-Applicant Details</h4>
                    <Row>
                      <Col md={6}>
                        <LabeledDropDown
                          name="co_applicant_relationship"
                          label="Relationship with Applicant"
                          options={[
                            { value: "spouse", label: "Spouse" },
                            { value: "father", label: "Father" },
                            { value: "mother", label: "Mother" },
                            { value: "son", label: "Son" },
                            { value: "daughter", label: "Daughter" },
                          ]}
                          registerOptions={{
                            required: "Relationship is required",
                          }}
                          required
                        />
                      </Col>
                      {coApplicantRelationships === "spouse" && (
                        <Col md={6}>
                          <LabeledInput
                            name="co_applicant_spouse_name"
                            label="Co-Applicant Spouse Name"
                            registerOptions={{
                              required: "Co-Applicant Spouse Name is required",
                            }}
                            required
                          />
                        </Col>
                      )}
                      {coApplicantRelationships === "father" && (
                        <Col md={6}>
                          <LabeledInput
                            name="co_applicant_fathers_name"
                            label="Co-Applicant Father Name"
                            registerOptions={{
                              required: "Co-Applicant Father Name is required",
                            }}
                            required
                          />
                        </Col>
                      )}
                      {coApplicantRelationships === "mother" && (
                        <Col md={6}>
                          <LabeledInput
                            name="co_applicant_mothers_name"
                            label="Co-Applicant Mother Name"
                            registerOptions={{
                              required: "Co-Applicant Mother Name is required",
                            }}
                            required
                          />
                        </Col>
                      )}
                      {coApplicantRelationships === "son" && (
                        <Col md={6}>
                          <LabeledInput
                            name="co_applicant_son_name"
                            label="Co-Applicant Son Name"
                            registerOptions={{
                              required: "Co-Applicant Son Name is required",
                            }}
                            required
                          />
                        </Col>
                      )}
                      {coApplicantRelationships === "daughter" && (
                        <Col md={6}>
                          <LabeledInput
                            name="co_applicant_daughter_name"
                            label="Co-Applicant Daughter Name"
                            registerOptions={{
                              required:
                                "Co-Applicant Daughter Name is required",
                            }}
                            required
                          />
                        </Col>
                      )}
                      <Col md={6}>
                        <LabeledInput
                          name="co_applicant_mobile"
                          label="Co-Applicant Mobile"
                          type="tel"
                          registerOptions={{
                            required: "Co-Applicant Mobile is required",
                          }}
                          required
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledInput
                          name="co_applicant_email"
                          label="Co-Applicant Email"
                          registerOptions={{
                            required: "Co-Applicant Email is required",
                          }}
                          required
                        />
                      </Col>
                    </Row>
                  </div>
                )}
              </div>
            )}

            {activeStep === 1 && (
              <div className="sections project-details-sections">
                <h4>Income Details</h4>
                <Row>
                  <Col md={6}>
                    <LabeledInput
                      label="Required Loan Amount"
                      type="text"
                      name="required_loan_amount"
                      registerOptions={validationRules.loanAmount}
                      error={errors.required_loan_amount?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      label="Annual Turn Over"
                      type="text"
                      name="turnover"
                      registerOptions={{
                        required: "Annual Turn Over is required",
                        min: {
                          value: 50000,
                          message: "Minimum required value is 50,000",
                        },
                        pattern: validationRules.validNumber.pattern,
                      }}
                      error={errors.turnover?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      label="Existing Total EMI"
                      name="existing_emi_amount"
                      type="text"
                      registerOptions={{
                        pattern: validationRules.validNumber.pattern,
                      }}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledDropDown
                      label="Your Company Registered As"
                      name="company_type"
                      options={[
                        { value: "Private Limited", label: "Private Limited" },
                        { value: "Proprietorship", label: "Proprietorship" },
                        { value: "LLP", label: "LLP" },
                        { value: "Not Registered", label: "Not Registered" },
                      ]}
                    />
                  </Col>
                  {adminRole !==  "customer" &&(
                    <Col md={6}>
                      <LabeledSelect
                        name="bank_name"
                        label="Bank Name"
                        options={businessLoanBanks}
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <LabeledDropDown
                      label="Nature of Business"
                      name="business_type"
                      options={[
                        { value: "Manufacturing", label: "Manufacturing" },
                        { value: "Retail", label: "Retail" },
                        { value: "Dealer", label: "Dealer" },
                        { value: "Distributer", label: "Distributer" },
                        { value: "Wholesale", label: "Wholesale" },
                        { value: "Service", label: "Service" },
                        { value: "Agriculture", label: "Agriculture" },
                        { value: "Real Estate", label: "Real Estate" },
                        { value: "Construction", label: "Construction" },
                        { value: "Builder", label: "Builder" },
                        { value: "E-Commerce", label: "E-Commerce" },
                        { value: "Transport", label: "Transport" },
                        { value: "Others", label: "Others" },
                      ]}
                      registerOptions={{ required: "Selection is required" }}
                      error={errors.business_type?.message}
                      required
                    />
                  </Col>
                  {watch("business_type") === "Others" && (
                    <Col md={6}>
                      <LabeledInput
                        name="description"
                        label="Others"
                        registerOptions={{
                          required: "Others is required",
                        }}
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <LabeledDropDown
                      name="business_property"
                      label="Business Place"
                      options={[
                        { value: "Own", label: "Own" },
                        { value: "Rent", label: "Rent" },
                        { value: "lease", label: "Lease" },
                      ]}
                      registerOptions={{ required: "Selection is required" }}
                      error={errors.business_property?.message}
                      required
                    />
                  </Col>
                  {watch("business_property") === "Own" && (
                    <Col md={6}>
                      <LabeledInput
                        name="business_year"
                        label="Business Start Year"
                        type="text"
                        registerOptions={{
                          required: "Business Start Year is required",
                          pattern: validationRules.validNumber.pattern,
                          validate: (value) => {
                            const enteredYear = parseInt(value, 10);
                            const currentYear = new Date().getFullYear();
                            if (isNaN(enteredYear)) {
                              return "Please enter a valid year";
                            }
                            if (enteredYear > currentYear) {
                              return `Future dates are not allowed`;
                            }
                            return true;
                          },
                        }}
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <LabeledDropDown
                      label="GST Registered"
                      name="gst_registered"
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      registerOptions={{ required: "Selection is required" }}
                      error={errors.gst_registered?.message}
                      required
                    />
                  </Col>
                  {watch("gst_registered") === "Yes" && (
                    <Col md={6}>
                      <LabeledInput
                        name="gst_registerd_year"
                        label="GST Registered Year"
                        type="text"
                        registerOptions={{
                          required: "GST Registered Year is required",
                          pattern: validationRules.validNumber.pattern,
                          validate: (value) => {
                            const selectedDate = new Date(value);
                            const today = new Date();
                            if (selectedDate > today) {
                              return "Future dates are not allowed";
                            }
                            return true;
                          },
                        }}
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <LabeledDropDown
                      name="msme_registered"
                      label="MSME Registered"
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      registerOptions={{ required: "Selection is required" }}
                      error={errors.msme_registered?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledDropDown
                      name="filling_itr"
                      label="Are You Filling ITR"
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      registerOptions={{ required: "Selection is required" }}
                      error={errors.filling_itr?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledDropDown
                      name="add_reference"
                      label="Add Reference"
                      options={[
                        { value: "Buyer / Seller", label: "Buyer / Seller" },
                        { value: "Friend / Relative", label: "Friend / Relative" }, 
                      ]}
                    />
                  </Col>

                  <h4>Reference Details</h4>
                  <Col md={6}>
                    <LabeledInput name="reference_name" label="Name" />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="reference_mobile"
                      label="Mobile"
                      type="tel"
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput name="reference_address" label="Address" />
                  </Col>
                  <Col md={6}>
                    <LabeledInput name="reference_location" label="Location" />
                  </Col>
                </Row>
              </div>
            )}

            {activeStep === 2 && (
              <div className="sections financial-details-sections">
                <h4>Please Upload Clear Copy</h4>
                <div className="form-row">
                  <div className="sections document-upload-sections">
                    <div className="document-upload-group">
                      <label
                        htmlFor="photo"
                        className="document-label required"
                      >
                        Photo <br />
                        (Selfie Recommend)
                      </label>
                      <div className="document-file-container">
                        <input
                          ref={fileRefs.photo}
                          label="Photo"
                          type="file"
                          name="photo"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                        {files.photo && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("photo")}
                          />
                        )}
                      </div>
                      <div className="button-group">
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleViewClick("photo")}
                        >
                          View
                        </button>
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleDownloadClick("photo")}
                        >
                          Download
                        </button>
                      </div>
                    </div>
                    <div className="document-upload-group">
                      <label
                        htmlFor="aadhar"
                        className="document-label required"
                      >
                        Aadhaar /eAadhaar
                      </label>
                      <div className="document-file-container">
                        <input
                          ref={fileRefs.aadhar}
                          label="Aadhar Card"
                          type="file"
                          name="aadhar"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                        {files.aadhar && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("aadhar")}
                          />
                        )}
                      </div>
                      <div className="button-group">
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleViewClick("aadhar")}
                        >
                          View
                        </button>
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleDownloadClick("aadhar")}
                        >
                          Download
                        </button>
                      </div>
                    </div>
                    <div className="document-upload-group">
                      <label htmlFor="pan" className="document-label required">
                        PAN Card
                      </label>
                      <div className="document-file-container">
                        <input
                          ref={fileRefs.pan}
                          label="PAN Card"
                          type="file"
                          name="pan"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                        {files.pan && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("pan")}
                          />
                        )}
                      </div>
                      <div className="button-group">
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleViewClick("pan")}
                        >
                          View
                        </button>
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleDownloadClick("pan")}
                        >
                          Download
                        </button>
                      </div>
                    </div>
                    {watch("gst_registered") === "Yes" && (
                      <div className="document-upload-group">
                        <label
                          htmlFor="gst"
                          className="document-label required"
                        >
                          GST Certificate
                        </label>
                        <div className="document-file-container">
                          <input
                            ref={fileRefs.gst}
                            label="Upload GST"
                            type="file"
                            name="gst"
                            onChange={handleFileChange}
                            className="form-control-file"
                          />
                          {files.gst && (
                            <FaTrashAlt
                              className="trash-icon"
                              title="Remove file"
                              onClick={() => handleClearFile("gst")}
                            />
                          )}
                        </div>
                        <div className="button-group">
                          <button
                            type="button"
                            className="view-btn"
                            onClick={() => handleViewClick("gst")}
                          >
                            View
                          </button>
                          <button
                            type="button"
                            className="view-btn"
                            onClick={() => handleDownloadClick("gst")}
                          >
                            Download
                          </button>
                        </div>
                      </div>
                    )}
                    <div className="document-upload-group">
                      <label
                        htmlFor="bank_account"
                        className="document-label required"
                      >
                        CA/OD/CC Account Statement <br /> (Last 12 Months)
                      </label>
                      <div className="document-file-container">
                        <input
                          ref={fileRefs.bank_account}
                          label="SB/CA Account"
                          type="file"
                          name="bank_account"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                        {files.bank_account && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("bank_account")}
                          />
                        )}
                      </div>
                      <span className="file-upload-message">
                        Upload only PDF files & without password
                      </span>
                      <div className="button-group">
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleViewClick("bank_account")}
                        >
                          View
                        </button>
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleDownloadClick("bank_account")}
                        >
                          Download
                        </button>
                      </div>
                    </div>

                    {watch("gst_registered") === "Yes" && (
                      <div className="document-upload-group">
                        <label htmlFor="msme" className="document-label">
                          GST 3B <br /> (Last 18 Months)
                        </label>
                        <div className="document-file-container">
                          <input
                            ref={fileRefs.msme}
                            label=" Upload MSME"
                            type="file"
                            name="msme"
                            onChange={handleFileChange}
                            className="form-control-file"
                          />
                          {files.msme && (
                            <FaTrashAlt
                              className="trash-icon"
                              title="Remove file"
                              onClick={() => handleClearFile("msme")}
                            />
                          )}
                        </div>
                        <div className="button-group">
                          <button
                            type="button"
                            className="view-btn"
                            onClick={() => handleViewClick("msme")}
                          >
                            View
                          </button>
                          <button
                            type="button"
                            className="view-btn"
                            onClick={() => handleDownloadClick("msme")}
                          >
                            Download
                          </button>
                        </div>
                      </div>
                    )}

                    {watch("filling_itr") === "Yes" && (
                      <div className="document-upload-group">
                        <label
                          htmlFor="itr"
                          className="document-label required"
                        >
                          ITR Last 2 Years
                        </label>
                        <div className="document-file-container">
                          <input
                            ref={fileRefs.itr}
                            label="Upload Last 2 year ITR"
                            type="file"
                            name="itr"
                            onChange={handleFileChange}
                            className="form-control-file"
                          />
                          {files.itr && (
                            <FaTrashAlt
                              className="trash-icon"
                              title="Remove file"
                              onClick={() => handleClearFile("itr")}
                            />
                          )}
                        </div>
                        <div className="button-group">
                          <button
                            type="button"
                            className="view-btn"
                            onClick={() => handleViewClick("itr")}
                          >
                            View
                          </button>
                          <button
                            type="button"
                            className="view-btn"
                            onClick={() => handleDownloadClick("itr")}
                          >
                            Download
                          </button>
                        </div>
                      </div>
                    )}

                    <div className="document-upload-group">
                      <label htmlFor="others" className="document-label">
                        Others
                      </label>
                      <div className="document-file-container">
                        <input
                          ref={fileRefs.others}
                          label=" Upload Others"
                          type="file"
                          name="others"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                        {files.others && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("others")}
                          />
                        )}
                      </div>
                      <div className="button-group">
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleViewClick("others")}
                        >
                          View
                        </button>
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleDownloadClick("others")}
                        >
                          Download
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {watch("add_co_applicant") === "Yes" && (
                  <>
                    <h4 className="applicant-kyc-heading">
                      ADD Co Applicant KYC
                    </h4>
                    <div className="sections financial-details-sections">
                      <div className="form-row">
                        <div className="sections document-upload-sections">
                          <div className="document-upload-group">
                            <label
                              htmlFor="co_applicant_pan"
                              className="document-label required"
                            >
                              Co Applicant Pan Card
                            </label>
                            <div className="document-file-container">
                              <input
                                ref={fileRefs.co_applicant_pan}
                                label="Co Applicant Pan Card"
                                type="file"
                                name="co_applicant_pan"
                                onChange={handleFileChange}
                                className="form-control-file"
                              />
                              {files.co_applicant_pan && (
                                <FaTrashAlt
                                  className="trash-icon"
                                  title="Remove file"
                                  onClick={() => handleClearFile("co_applicant_pan")}
                                />
                              )}
                            </div>
                            <div className="button-group">
                              <button
                                type="button"
                                className="view-btn"
                                onClick={() => handleViewClick("co_applicant_pan")}
                              >
                                View
                              </button>
                              <button
                                type="button"
                                className="view-btn"
                                onClick={() => handleDownloadClick("co_applicant_pan")}
                              >
                                Download
                              </button>
                            </div>
                          </div>
                          <div className="document-upload-group">
                            <label
                              htmlFor="co_applicant_aadhar"
                              className="document-label required"
                            >
                              Co Applicant Aadhar Card
                            </label>
                            <div className="document-file-container">
                              <input
                                ref={fileRefs.co_applicant_aadhar}
                                label="Co Applicant Aadhar Card"
                                type="file"
                                name="co_applicant_aadhar"
                                onChange={handleFileChange}
                                className="form-control-file"
                              />
                              {files.co_applicant_aadhar && (
                                <FaTrashAlt
                                  className="trash-icon"
                                  title="Remove file"
                                  onClick={() => handleClearFile("co_applicant_aadhar")}
                                />
                              )}
                            </div>
                            <div className="button-group">
                              <button
                                type="button"
                                className="view-btn"
                                onClick={() => handleViewClick("co_applicant_aadhar")}
                              >
                                View
                              </button>
                              <button
                                type="button"
                                className="view-btn"
                                onClick={() => handleDownloadClick("co_applicant_aadhar")}
                              >
                                Download
                              </button>
                            </div>
                          </div>
                          <div className="document-upload-group">
                            <label
                              htmlFor="co_applicant_photo"
                              className="document-label required"
                            >
                              Photo (Selfie Recommend)
                            </label>
                            <div className="document-file-container">
                              <input
                                ref={fileRefs.co_applicant_photo}
                                label="Co Applicant Photo"
                                type="file"
                                name="co_applicant_photo"
                                onChange={handleFileChange}
                                className="form-control-file"
                              />
                              {files.co_applicant_photo && (
                                <FaTrashAlt
                                  className="trash-icon"
                                  title="Remove file"
                                  onClick={() => handleClearFile("co_applicant_photo")}
                                />
                              )}
                            </div>
                            <div className="button-group">
                              <button
                                type="button"
                                className="view-btn"
                                onClick={() => handleViewClick("co_applicant_photo")}
                              >
                                View
                              </button>
                              <button
                                type="button"
                                className="view-btn"
                                onClick={() => handleDownloadClick("co_applicant_photo")}
                              >
                                Download
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
          <div className="button-container">
            <Row className="mt-4">
              <Col className="text-end">
                {activeStep > 0 && (
                  <Button
                    variant="secondary"
                    onClick={() => handleStepChange(activeStep - 1)}
                    className="custom-back-button"
                  >
                    Go Back
                  </Button>
                )}
                {activeStep < steps.length - 1 && (
                  <Button
                    variant="primary"
                    onClick={() => handleStepChange(activeStep + 1)}
                    className="custom-next-button"
                  >
                    Next Step
                  </Button>
                )}
                {activeStep === steps.length - 1 &&
                  !(adminRole === "customer" && selectedStatus === "Approved") && (
                  <Button
                    type="submit"
                    variant="primary"
                    className="custom-submit-button"
                  >
                    {loading ? "Processing..." : "Update"}
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </form>
      </FormProvider>
      <ToastContainer />
    </div>
  );
};

export default EditBusinessLoan;
